import { FlowChartBlockType } from 'common/builder/components/chart/FlowChart/types/FlowChartBlock'

export const NonContentBlocks = [
  FlowChartBlockType.QUICK_REPLIES,
  FlowChartBlockType.TELEGRAM_KEYBOARD,
]
